module.exports = __webpack_public_path__ + "static/media/logo@3x.17991bc5.png";